import { z } from 'zod';

const keyValueSchema = z.object({
  key: z.union([z.string(), z.number()]),
  value: z.string().nullish(),
});

const keyValueDefaultSchema = keyValueSchema.extend({
  default: z.string(),
});


const formValueRowSchema = z.object({
  answeredPrice: z.union([z.string(), z.number()]),
  deliveryBySupplier: z.boolean(),
  guidBrand: z.string(),
  guidPackageType: z.string().nullish(),
  guidQuote: z.string(),
  guidQuoteItem: z.string(),
  guidQuoteSupplier: z.string(),
  guidWarehouse: z.string(),
  guidReason: z.string().nullish(),
  idPartType: z.number(),
  idQuoteItem: z.number(),
  idUnique: z.string(),
  isInventoryResponse: z.boolean(),
  isPendingAnswer: z.boolean(),
  national: z.boolean().nullish(),
  notQuote: z.boolean(),
  observation: z.string().nullish(),
  partTypeName: z.string(),
  pickupTime: z.string(),
  reason: keyValueDefaultSchema.nullish(),
  showNoPriceWarning: z.boolean(),
  partBrandName: keyValueSchema.nullish(),
  packageTypeName: keyValueSchema.nullish(),
  warehouseName: keyValueSchema.nullish(),
  weight: z.string(),
  height: z.union([z.number(), z.string()]),
  width: z.union([z.number(), z.string()]),
  depth: z.union([z.number(), z.string()]),
  partNumber: z.string(),
  stock: z.string(),
  price: z.union([z.string(), z.number()]).nullish(),
  guidQuoteSupplierItem: z.string().nullish(),
  isGroupHidden: z.boolean().nullish(),
  validateWhenOnlyOneWarehouse: z.boolean().nullish(),
  isNagsLoading: z.boolean().nullish(),
  isNagsLocked: z.boolean().nullish(),
  nagsPrice: z.union([z.string(), z.number()]).nullish(),
  quoteProcurementPartInfo: z.object({
    partName: z.string().nullish(),
    quoteItemDescription: z.string().nullish(),
    quoteItemPartNumber: z.string().nullish(),
  }),
});

export type IFormValueRow = z.infer<typeof formValueRowSchema>;

export function pendingItemSchema(isDelivery: boolean) {
  return formValueRowSchema.superRefine((item, ctx) => {   
    if (item.isGroupHidden || item.notQuote || item.validateWhenOnlyOneWarehouse === false) return;

    if (!item.answeredPrice) {
      ctx.addIssue({ code: 'custom', path: ['answeredPrice'], message: 'required' });
    }
    if (!item.warehouseName) {
      ctx.addIssue({ code: 'custom', path: ['warehouseName'], message: 'required' });
    }
    if (!item.stock || Number(item.stock) <= 0) {
      ctx.addIssue({ code: 'custom', path: ['stock'], message: 'required' });
    }
    if ((!item.pickupTime || Number(item.pickupTime) <= 0)) {
      ctx.addIssue({ code: 'custom', path: ['pickupTime'], message: 'required' });
    }

    if (!isDelivery) {
      if (!item.height || Number(item.height) <= 0) {
        ctx.addIssue({ code: 'custom', path: ['height'], message: 'required' });
      }
      if (!item.width || Number(item.width) <= 0) {
        ctx.addIssue({ code: 'custom', path: ['width'], message: 'required' });
      }
      if (!item.depth || Number(item.depth) <= 0) {
        ctx.addIssue({ code: 'custom', path: ['depth'], message: 'required' });
      }
      if (!item.weight || Number(item.weight) <= 0) {
        ctx.addIssue({ code: 'custom', path: ['weight'], message: 'required' });
      }
    }
  });
}

export function createAnswerSchema(isDelivery: boolean) {
  return z.object({
    pendingItems: z.array(pendingItemSchema(isDelivery)),
    answeredItems: z.array(formValueRowSchema),
  });
}
export function validateAnsweredItemForEdit(item: IFormValueRow) {
  return pendingItemSchema(Boolean(item.deliveryBySupplier)).safeParse(item);
}
